module.exports = __webpack_public_path__ + "img/class-satisfaction.09610d61.png";